<fieldset>
  <legend>
    RensComplementairesDivers
  </legend>
  <fieldset>
    <legend>
      intituleLibre
    </legend>
    <app-form-input  [label]="'intituleLibre'"
                    [name]="getUid()+'_SepAtt_intituleLibre'"
                    [parentForm]="parentForm" [rule]="''" [type]="'tofix'"
                    [value]="rensComplt.intLibre.intituleLibre">
    </app-form-input>

    <app-form-input  [label]="'intituleLibreLibelle'"
                    [name]="getUid()+'_SepAtt_intituleLibreLibelle'"
                    [parentForm]="parentForm" [rule]="''" [type]="'tofix'"
                    [value]="rensComplt.intLibre.intituleLibreLibelle">
    </app-form-input>
  </fieldset>
  <fieldset>
    <legend>
      txtLibre
    </legend>
    <app-champ-libre-group [champLibreGroup]="rensComplt.txtLibre" [parentForm]="parentForm"
                           [uid]="getUid()"></app-champ-libre-group>
  </fieldset>
</fieldset>
